// extracted by mini-css-extract-plugin
export default {"footerButtons":"+8LQl","selectNumberOfProducs":"KRAaL","selectedCount":"znxUT","valueButton":"OZ9w1"};